import { apiEmpleo } from "../../util/ApiEmpleo";

const apiGetService = async (serviceId: string) => {
  let res = await apiEmpleo.get(`services/${serviceId}`);

  return res;
};

export { apiGetService };
